import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";
import { collections } from "@/mocks/collections";
import { getCategory } from "@/lib/content";

export default function TrendingBoard() {
  const ranking = [...collections].slice(0, 5);
  const latest = [...collections].reverse().slice(0, 4);

  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-20" aria-labelledby="home-trending-title">
      <div className="max-w-7xl mx-auto">
        <SectionTitle
          eyebrow="RANKING"
          title="本期热榜与最新更新"
          desc="热榜按站内阅读与讨论热度排序，最新更新则记录刚刚补进合集的片段，方便你跟上进度的变化。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-7">
            <ol className="flex flex-col">
              {ranking.map((item, index) => {
                const category = getCategory(item.category);
                return (
                  <li key={item.id}>
                    <Link
                      to={`/collections/${item.id}`}
                      className="group flex items-start gap-4 md:gap-6 py-5 border-b border-background-200 hover:bg-background-100 transition-colors px-2 md:px-4 rounded-md"
                    >
                      <span className="font-heading text-2xl md:text-3xl font-black text-background-300 group-hover:text-primary-500 transition-colors w-10 shrink-0">
                        {String(index + 1).padStart(2, "0")}
                      </span>
                      <span className="flex flex-col flex-1 min-w-0">
                        <span className="flex items-center gap-2 flex-wrap">
                          {category && (
                            <span className="text-xs px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-800">
                              {category.name}
                            </span>
                          )}
                          <span className="text-xs text-foreground-500">{item.date}</span>
                        </span>
                        <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug mt-2 group-hover:text-primary-700 transition-colors">
                          {item.title}
                        </h3>
                        <span className="text-xs text-foreground-500 mt-2 flex items-center gap-3">
                          <span className="flex items-center gap-1">
                            <i className="ri-eye-line" aria-hidden="true" />
                            {item.views}
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-time-line" aria-hidden="true" />
                            {item.readTime}
                          </span>
                        </span>
                      </span>
                    </Link>
                  </li>
                );
              })}
            </ol>
          </div>

          <div className="lg:col-span-5">
            <div className="bg-background-100 border border-background-200 rounded-lg p-5 md:p-6 h-full">
              <h3 className="font-heading text-lg font-bold text-foreground-950 flex items-center gap-2 mb-5">
                <i className="ri-refresh-line text-primary-600" aria-hidden="true" />
                最新补充
              </h3>
              <ul className="flex flex-col gap-4">
                {latest.map((item) => (
                  <li key={item.id}>
                    <Link
                      to={`/collections/${item.id}`}
                      className="group flex items-center gap-3"
                    >
                      <span className="w-20 h-14 rounded-md overflow-hidden bg-background-200 shrink-0">
                        <img
                          src={item.cover}
                          alt={`${item.title} 合集缩略图`}
                          title={item.title}
                          className="w-full h-full object-cover object-top"
                        />
                      </span>
                      <span className="flex flex-col min-w-0">
                        <span className="text-sm font-medium text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                          {item.title}
                        </span>
                        <span className="text-xs text-foreground-500 mt-1">
                          {item.drama} · {item.date}
                        </span>
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
              <Link
                to="/collections"
                className="mt-6 flex items-center justify-center gap-1.5 w-full py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                查看全部更新
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}